import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import CarCard from "./CarCard";
import "./Related.css";
import { MyContext } from "../Context/MyContext";

export default function RelatedModel({ modelId, currentId }) {
  const {cars} = useContext(MyContext);
  const navigate = useNavigate();

  const relatedCars = cars
    .filter(
      (car) => car.model_id === modelId && car.id !== currentId
    )
    .slice(0, 8);

  if (relatedCars.length === 0) return null;

  return (
    <div className="related-section">
      <div className="related-header">
        <h2>Related Model Cars</h2>

        <button
          className="more-btn"
          onClick={() => navigate(`/cars?model=${modelId}`)}
        >
          More →
        </button>
      </div>

      <div className="related-grid">
        {relatedCars.map((car) => (
          <CarCard key={car.id} car={car} />
        ))}
      </div>
    </div>
  );
}
